<div class="u4-card" id="cpp-search-result-{{ slug }}" tabindex="0"
     [class.disabled]="result === undefined || result === 0 || result === -1"
     (click)="navigate.emit({ slug: slug, params: params, href: href })"
     (keydown.enter)="$event.target.click()">
  <div class="u4-card__title-wrapper">
    <div class="u4-card__title">
      <h4>{{ labels[labelName] }}</h4>
    </div>
    <div class="u4-card__subtitle">
      {{ resultsLabel }}
    </div>
  </div>
  <div class="u4-card__image">
    <img [src]="imageUrl" [alt]="slug">
  </div>
</div>
